var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.15 21.41C15.72 21.41 15.29 21.32 14.94 21.15L9.69004 18.52C9.39004 18.37 8.80004 18.38 8.51004 18.55L6.15004 19.9C5.13004 20.48 4.08004 20.56 3.29004 20.09C2.49004 19.63 2.04004 18.69 2.04004 17.51V7.79C2.04004 6.88 2.64004 5.85 3.43004 5.4L7.76004 2.92C8.49004 2.5 9.60004 2.47 10.35 2.85L15.6 5.48C15.9 5.63 16.48 5.61 16.78 5.45L19.13 4.11C20.15 3.53 21.2 3.45 21.99 3.92C22.79 4.38 23.24 5.32 23.24 6.5V16.23C23.24 17.14 22.64 18.17 21.85 18.62L17.52 21.1C17.14 21.3 16.64 21.41 16.15 21.41ZM9.14004 16.92C9.57004 16.92 10 17.01 10.35 17.18L15.6 19.81C15.9 19.96 16.48 19.94 16.78 19.78L21.11 17.3C21.43 17.12 21.74 16.58 21.74 16.22V6.49C21.74 5.86 21.56 5.39 21.23 5.21C20.91 5.03 20.41 5.1 19.87 5.41L17.52 6.75C16.79 7.17 15.68 7.2 14.93 6.82L9.68004 4.19C9.38004 4.04 8.80004 4.06 8.50004 4.22L4.17004 6.7C3.85004 6.88 3.54004 7.42 3.54004 7.79V17.52C3.54004 18.15 3.72004 18.62 4.04004 18.8C4.36004 18.99 4.86004 18.91 5.41004 18.6L7.76004 17.26C8.15004 17.03 8.65004 16.92 9.14004 16.92Z",
    fill: "#60656C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05957 17.75C8.64957 17.75 8.30957 17.41 8.30957 17V4C8.30957 3.59 8.64957 3.25 9.05957 3.25C9.46957 3.25 9.80957 3.59 9.80957 4V17C9.80957 17.41 9.46957 17.75 9.05957 17.75Z",
    fill: "#60656C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2305 20.75C15.8205 20.75 15.4805 20.41 15.4805 20V6.62C15.4805 6.21 15.8205 5.87 16.2305 5.87C16.6405 5.87 16.9805 6.21 16.9805 6.62V20C16.9805 20.41 16.6405 20.75 16.2305 20.75Z",
    fill: "#60656C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgState);
export default __webpack_public_path__ + "static/media/state.08a66b45f98eeaedb92e066844bffff3.svg";
export { ForwardRef as ReactComponent };